import { theme } from 'theme/App.theme';
import makeStyles from '@mui/styles/makeStyles';
import { appPalette } from 'theme/App.palette';

const colors = appPalette.colors;

export const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  telephoneLink: {
    display: 'flex',
    flexDirection: 'row',
    textDecoration: 'none',
    '& .cta-label': {
      display: 'flex',
      ...(theme.themeName === 'honda' && {
        alignItems: 'center',
        color: colors.honda_blue,
      }),
    },
  },
  department_title: {
    ...(theme.themeName === 'honda' && {
      color: colors.dark_blue_1,
      '&.mobile': {
        marginBottom: '0.75rem',
      },
    }),
  },
  departmentContainer: {
    '&:not(:last-child)': {
      borderBottom: `0.125rem solid ${colors.off_white}`,
    },
    justifyContent: 'space-between',
    margin: '0 1.25rem',
    padding: '0.625rem 0',
  },
  displayDesktop: {
    display: 'none',
    [theme.breakpoints.up('viewportMedium')]: {
      display: 'flex',
      marginBottom: '0.75rem',
    },
  },
  hideDesktop: {
    [theme.breakpoints.up('viewportMedium')]: {
      display: 'none',
    },
  },
  hours_container: {
    ...(theme.themeName === 'honda' && {
      marginTop: '2.25rem',
      [theme.breakpoints.up('viewportMedium')]: {
        marginTop: '0',
      },
    }),
  },
  hour_text: {
    ...(theme.themeName === 'honda' && {
      color: colors.dark_blue_1,
    }),
  },
  phoneDesktop: {
    padding: '0.9375rem 0.625rem',
    '& svg': {
      marginRight: '0.625rem',
    },
  },
});
